// extracted by mini-css-extract-plugin
export default {"dialog_wrapper":"DialogPrompt_dialog_wrapper__ECST+","icon":"DialogPrompt_icon__8qSyI","close_icon":"DialogPrompt_close_icon__VGOqQ"};